namespace Newtonsoft.ViewModels.Store {
    export class AccountRenewViewModel {
        emailAddress = ko.observable<string>()
            .extend({
                required: {
                    params: true,
                    message: "Your email address is required"
                }
            });
        password = ko.observable<string>()
            .extend({
                required: {
                    params: true,
                    message: "Password is required"
                }
            });
        validation: any;

        constructor() {
            this.validation = ko.validatedObservable(this);
        }
    }

    export class OrderReferenceRenewViewModel {
        orderReference = ko.observable<string>()
            .extend({
                required: {
                    params: true,
                    message: "An order reference is required"
                }
            });
        validation: any;

        constructor() {
            this.validation = ko.validatedObservable(this);
        }
    }

    export class LicenseKeyRenewViewModel {
        licenseKey = ko.observable<string>()
            .extend({
                required: {
                    params: true,
                    message: "A license key is required"
                }
            });
        validation: any;

        constructor() {
            this.validation = ko.validatedObservable(this);
        }
    }

    interface IRenewSearchModel {
        licenseId: number;
        coupon: string;
        urlPath: string;
        renewUrlPath: string;
    }

    export class RenewViewModel {
        accountViewModel: AccountRenewViewModel;
        orderReferenceViewModel: OrderReferenceRenewViewModel;
        licenseKeyViewModel: LicenseKeyRenewViewModel;

        tokenHeader = ko.observable<string>();

        constructor(tokenHeader) {
            this.tokenHeader(tokenHeader);
            this.accountViewModel = new AccountRenewViewModel();
            this.orderReferenceViewModel = new OrderReferenceRenewViewModel();
            this.licenseKeyViewModel = new LicenseKeyRenewViewModel();
        }

        async login() {
            if (!this.accountViewModel.validation.isValid()) {
                this.accountViewModel.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                emailAddress: this.accountViewModel.emailAddress(),
                password: this.accountViewModel.password(),
                rememberMe: false
            });

            Newtonsoft.showLoading("body");

            try {
                const response = await fetch("/api/account/login", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    window.location.href = "/account/licenses";
                } else {
                    await Newtonsoft.handleFailure(this.accountViewModel, response);
                }
            } finally {
                Newtonsoft.hideLoading("body");
            }
        }

        async checkLicenseKey() {
            if (!this.licenseKeyViewModel.validation.isValid()) {
                this.licenseKeyViewModel.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                licenseKey: this.licenseKeyViewModel.licenseKey()
            });

            Newtonsoft.showLoading("body");

            try {
                const response = await fetch("/api/license/checkLicenseKey", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    const d: IRenewSearchModel = await response.json();
                    window.location.href = d.renewUrlPath;
                } else {
                    await Newtonsoft.handleFailure(this.licenseKeyViewModel, response);
                }
            } finally {
                Newtonsoft.hideLoading("body");
            }
        }

        async checkOrderReference() {
            if (!this.orderReferenceViewModel.validation.isValid()) {
                this.orderReferenceViewModel.validation.errors.showAllMessages();
                return;
            }

            var json = JSON.stringify({
                orderReference: this.orderReferenceViewModel.orderReference()
            });

            Newtonsoft.showLoading("body");

            try {
                const response = await fetch("/api/license/checkOrderReference", {
                    method: "POST",
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Csrf-Token': this.tokenHeader()
                    },
                    body: json
                });

                if (response.ok) {
                    const d: IRenewSearchModel = await response.json();
                    window.location.href = d.renewUrlPath;
                } else {
                    await Newtonsoft.handleFailure(this.orderReferenceViewModel, response);
                }
            } finally {
                Newtonsoft.hideLoading("body");
            }
        }
    }
}
